export default __webpack_public_path__ + "static/media/pm.076a83c8.svg";